<template>
    <div class="d-flex d-inline-flex flex-column">
        <img
            style="max-width:100%"
            v-if="upload.type === 'image' || /image.*/.test(upload.type)"
            :src="img(upload)"
        />
        <audio
            v-else-if="upload.type === 'audio' || /audio\/*/.test(upload.mime)"
            controls
            style="max-width:100%;width: 100%"
            :src="src(upload)"
        >
            {{ $t('common.browser_support_file') }}
        </audio>
        <video
            v-else-if="upload.type === 'video' || /video\/*/.test(upload.mime)"
            controls
            style="max-width:100%;width: 100%"
            :src="src(upload)"
        >
            {{ $t('common.browser_support_file') }}
        </video>
        <div v-else class="d-flex flex-column justify-content-center align-center">
            <div class="d-flex justify-content-center">
                <span class="my-3 display-4 text-center" :class="icon(upload.mime)"></span>
            </div>
            <div class="d-flex justify-content-center">
                <a
                    :href="src(upload)"
                    download
                    target="_blank"
                    class="h5"
                    style="cursor:pointer;display: block"
                >
                    {{ $t('common.download_file') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    emits: ['input', 'update:modelValue'],
        name: 'TicketReplyAttachmentOpen',

        props: {
            modelValue: Object,
            size: {
                type: String,
                default: 'md'
            }
        },

        computed: {
            upload: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit('update:modelValue', value);
                    this.$emit('input', value);
                }
            },
        },

        methods: {

            src({host, original_file, urls}) {
                if (urls && urls.original) {
                    return urls.original;
                }
                return `/storage/${host}/original/${original_file}`;
            },

            img({host, original_file, urls}) {
                if (this.dataURL) return this.dataURL;
                if (urls && urls[this.size]) {
                    return urls[this.size];
                }
                return `/storage/${host}/${this.size}/${original_file}`;
            },

            icon(type) {
                switch(true){
                    case /video\/.*/.test(type): return 'fas fa-file-video fa-lg'
                    case /audio\/.*/.test(type): return 'fas fa-file-audio fa-lg'
                    case /application\/pdf/.test(type): return 'fas fa-file-pdf fa-lg'
                    default: return 'fas fa-file fa-lg';
                }
            },
        }
    }
</script>
